import * as React from 'react';

import {FormField} from 'shells/form/form-field';
import {Radio} from 'shells/radio/radio';
import {RadioGroup} from 'shells/radio/radio-group';

import type {SmtpPortType} from 'nutshell-graphql-types';

import styles from './port-type.module.css';

type Props = {
    value: SmtpPortType;
    onChange: (arg1: SmtpPortType) => void;
};

export function PortType(props: Props) {
    return (
        <div className={styles['port-type']}>
            <FormField
                innerId='portType'
                label='Port type'
                errorMessage={null} // TODO
            >
                <RadioGroup
                    name='portType'
                    inline={true}
                    selectedValue={props.value}
                    // @ts-expect-error
                    onChange={props.onChange}
                >
                    <Radio value='SSL'>SSL</Radio>
                    <Radio value='TLS'>TLS</Radio>
                </RadioGroup>
            </FormField>
        </div>
    );
}
